var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgILightBulb = function SvgILightBulb(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15248_113527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.75 15H8.75C8.75 15.825 8.075 16.5 7.25 16.5C6.425 16.5 5.75 15.825 5.75 15ZM4.25 13.5C4.25 13.9125 4.5875 14.25 5 14.25H9.5C9.9125 14.25 10.25 13.9125 10.25 13.5C10.25 13.0875 9.9125 12.75 9.5 12.75H5C4.5875 12.75 4.25 13.0875 4.25 13.5ZM12.875 7.125C12.875 9.99 10.88 11.52 10.0475 12H4.4525C3.62 11.52 1.625 9.99 1.625 7.125C1.625 4.02 4.145 1.5 7.25 1.5C10.355 1.5 12.875 4.02 12.875 7.125ZM16.5275 5.5275L15.5 6L16.5275 6.4725L17 7.5L17.4725 6.4725L18.5 6L17.4725 5.5275L17 4.5L16.5275 5.5275ZM14.75 4.5L15.455 2.955L17 2.25L15.455 1.545L14.75 0L14.045 1.545L12.5 2.25L14.045 2.955L14.75 4.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15248_113527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgILightBulb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/i-light-bulb.73315ae2b3bb31a3ab184ba3d792d3ef.svg";